
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/author/[id]/page/[page]",
      function () {
        return require("private-next-pages/blog/author/[id]/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/author/[id]/page/[page]"])
      });
    }
  